import { t } from 'i18next';

import { DataTableColumn } from 'components/dataTable';

import { CryptoPayoutStatus } from 'types/cryptoPayout';

export const KEYS = {
  FILTER_KEY: 'cryptoPayouts',
  ITEMS_PER_PAGE_OPTIONS: [15, 20, 50, 100],
  SEARCH_DEBOUNCE_TIMEOUT: 700,
  DATE_FORMAT: 'MMM DD, HH:mm A',
  CRYPTO_SYMBOL_SEPARATOR: '.',
  CRYPTO_NETWORK_SPACING_SYMBOLS_EXP: /[_]/gi,
};

export const filterStatusGroups = {
  initiated: [CryptoPayoutStatus.Initiated],
  pending: [CryptoPayoutStatus.Pending],
  submitted: [CryptoPayoutStatus.Submitted],
  confirmed: [CryptoPayoutStatus.Confirmed],
  completed: [CryptoPayoutStatus.Completed],
  canceled: [CryptoPayoutStatus.Canceled],
  failed: [CryptoPayoutStatus.Failed],
};

export const LABELS = {
  BREADCRUMBS: [['page.cryptoPayout.breadcrumbs', 'Payouts']],
  PAGE_TITLE: ['page.cryptoPayout.list.title', 'Payout Listing'],
  SEARCH_PLACEHOLDER_S4USER: ['page.cryptoPayout.list.search.placeholderS4User', 'Search by Payout ID, User or Account ID, User Email'],
  SEARCH_PLACEHOLDER_PARTNER: ['page.cryptoPayout.list.search.placeholderPartner', 'Search by Order ID, User Email'],
  CSV_DOWNLOAD_ERROR: ['page.cryptoPayout.list.csv.downloadError', 'Something went wrong, please try again later'],
  CSV_FILE_NAME: ['page.cryptoPayout.list.csv.fileName', 'Crypto payouts export {{date}}.csv'],
  EXPORT_MODAL_TITLE: ['page.cryptoPayout.list.export.modalTitle', 'Export Payout List'],
  FILTERS: {
    STATUS: {
      LABEL: ['page.cryptoPayout.list.filter.status.label', 'Status'],
      INITIATED: ['page.cryptoPayout.list.filter.status.initiated', 'Initiated'],
      PENDING: ['page.cryptoPayout.list.filter.status.pending', 'Pending'],
      SUBMITTED: ['page.cryptoPayout.list.filter.status.submitted', 'Submitted'],
      CONFIRMED: ['page.cryptoPayout.list.filter.status.completed', 'Confirmed'],
      COMPLETED: ['page.cryptoPayout.list.filter.status.completed', 'Completed'],
      CANCELED: ['page.cryptoPayout.list.filter.status.canceled', 'Canceled'],
      FAILED: ['page.cryptoPayout.list.filter.status.failed', 'Failed'],
    },
    DATE: {
      LABEL: ['page.cryptoPayout.list.filter.date.label', 'Date'],
    },
    FIAT_CURRENCY: {
      LABEL: ['page.cryptoPayout.list.filter.fiatCurrency.label', 'Fiat Currency'],
    },
    PAYOUT_AMOUNT: {
      LABEL: ['page.cryptoPayout.list.filter.orderAmount.label', 'Payout Amount'],
    },
    MERCHANT: {
      LABEL: ['page.cryptoPayout.list.filter.merchant.label', 'Merchant Account'],
      PLACEHOLDER: ['page.cryptoPayout.list.filter.merchant.placeholder', 'Select one'],
    },
  },
  TABLE_COLUMNS: {
    STATUS: ['page.cryptoPayout.list.table.columns.status', 'Status'],
    ID: ['page.cryptoPayout.list.table.columns.id', 'Payout ID'],
    DATE: ['page.cryptoPayout.list.table.columns.date', 'Date'],
    USER: ['page.cryptoPayout.list.table.columns.user', 'User'],
    FIAT_AMOUNT: ['page.cryptoPayout.list.table.columns.fiatAmount', 'Fiat Amount'],
    CRYPTO_AMOUNT: ['page.cryptoPayout.list.table.columns.cryptoAmount', 'Crypto Amount'],
    ACTIONS: ['page.cryptoPayout.list.table.columns.actions', ''],
  },
};

export const COLUMN_IDS = {
  STATUS: 'status',
  ID: 'uuid',
  DATE: 'createdAt',
  USER: 'customerEmail',
  FIAT_AMOUNT: 'fiatAmount',
  FIAT_CURRENCY: 'fiatCurrencyCode',
  CRYPTO_AMOUNT: 'cryptoAmount',
  CRYPTO_CURRENCY: 'cryptoCurrencyCode',
  ACTIONS: 'actions',
};

export const COLUMNS: DataTableColumn[] = [
  { id: COLUMN_IDS.STATUS, label: t(LABELS.TABLE_COLUMNS.STATUS) },
  { id: COLUMN_IDS.ID, label: t(LABELS.TABLE_COLUMNS.ID), sortable: true },
  { id: COLUMN_IDS.DATE, label: t(LABELS.TABLE_COLUMNS.DATE), sortable: true },
  { id: COLUMN_IDS.USER, label: t(LABELS.TABLE_COLUMNS.USER) },
  { id: COLUMN_IDS.FIAT_AMOUNT, label: t(LABELS.TABLE_COLUMNS.FIAT_AMOUNT) },
  { id: COLUMN_IDS.CRYPTO_AMOUNT, label: t(LABELS.TABLE_COLUMNS.CRYPTO_AMOUNT) },
  { id: COLUMN_IDS.ACTIONS, label: t(LABELS.TABLE_COLUMNS.ACTIONS) },
];
